import {createSlice} from '@reduxjs/toolkit';
import layouts from '../../layouts';

const savedLayout = JSON.parse(localStorage.getItem('widgets'));

const DASHBOARD_A_LAYOUT_REVISION = 2;

const DASHBOARD_A_WIDGETS = [
    'stats-patients',
    'stats-appointments-today',
    'stats-appointments-week',
    'stats-open-prospects',
    'stats-studies',
    'stats-low-stock',
    'financial-flow-chart',
    'pipeline-chart',
    'top-companies-chart',
    'upcoming-appointments-real',
    'inventory-low-stock-chart'
];

const isDashboardALayoutCurrent = layout => {
    if (layout?.dashboard_a?.revision !== DASHBOARD_A_LAYOUT_REVISION) {
        return false;
    }

    if (!layout?.dashboard_a?.lg || !Array.isArray(layout.dashboard_a.lg)) {
        return false;
    }

    const currentItems = layout.dashboard_a.lg.map(item => item.i);
    return DASHBOARD_A_WIDGETS.every(id => currentItems.includes(id));
};

const resolveInitialLayout = () => {
    if (!savedLayout) {
        return layouts;
    }

    const merged = {
        ...layouts,
        ...savedLayout,
        dashboard_a: isDashboardALayoutCurrent(savedLayout) ? savedLayout.dashboard_a : layouts.dashboard_a
    };

    return merged;
};

export const Layout = createSlice({
    name: 'layout',
    initialState: {
        layout: resolveInitialLayout(),
    },
    reducers: {
        saveToLocalStorage: (state) => {
            localStorage.setItem('widgets', JSON.stringify(state.layout));
        },
        updateLayout: (state, action) => {
            const key = action.payload.id;
            state.layout[key].lg = action.payload.layouts;
        },
        resetLayout: (state, action) => {
            const key = action.payload.id;
            state.layout[key].lg = layouts[key].lg;
        }
    }
})

export const {saveToLocalStorage, updateLayout, resetLayout} = Layout.actions
export default Layout.reducer